export const ADMIN_EMAIL = 'app@islam-iznutra.com';

export const isAdminEmail = (email = '') => String(email || '').trim().toLowerCase() === ADMIN_EMAIL;